import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cocurricular-events',
  templateUrl: './cocurricular-events.component.html',
  styleUrls: ['./cocurricular-events.component.scss']
})
export class CocurricularEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
